<template>
<div>
    <b-modal ref="modal" title="Autorizar NF-e" header-class="border-bottom-0" size="md">
        <div>
            <h5>#{{number}}</h5>
        </div>
        <div slot="modal-footer">
            <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
                <i class="fas fa-times"></i> Voltar
            </button>
            <button role="button" class="btn btn-success" style="margin-left:5px" @click="sendNfeSefaz">
                <i class="fas fa-check"></i> Enviar NF
            </button>
        </div>
        <error-handler :error="error" />
        <b-alert :show="alertData.isVisible" fade variant="danger" @dismissed="alertData.isVisible = false" dismissible>{{ alertData.message }}</b-alert>
    </b-modal>
</div>
</template>

<script>
import Form from './../../../mixins/Form'

export default {
    data: function () {
        return {

            form: new Form({}),

            number: {},

            error: null,

            alertData: {
                isVisible: false,
                message: null
            }
        }
    },
    methods: {
        open(id = null, nNF) {

            this.nfeId = id;

            this.number = nNF;

            this.resetForm();

            this.$refs.modal.show();

        },

        sendNfeSefaz(nfeId) {
            this.$store.commit("showLoading");

            axios
                .post("api/nfe/send/" + this.nfeId)
                .then(response => {

                    this.$store.commit("hideLoading");

                    this.$refs.modal.hide();

                    this.$emit("stored");

                    this.$store.commit("showAlert", {
                    message: "Nota Fiscal Autorizada",
                    type: "success"
            });
                })
                .catch(error => {
                    this.$store.commit("hideLoading");
                    this.error = error;
                });
        },

        resetForm() {
            this.error = null;

            this.alertData.isVisible = false;

            this.form.reset();
        }
    }
};
</script>

<style>
</style>
